const KEY = "mfg-ba-pending-session";

export function queueBuilderAssistantSession(
  sessionId: string,
  categoryId?: string | null,
  reportOnly?: boolean,
) {
  sessionStorage.setItem(
    KEY,
    JSON.stringify({ sessionId, categoryId: categoryId ?? null, reportOnly: reportOnly === true }),
  );
  window.dispatchEvent(new Event("mfg-ba-pending-session"));
}

export function takeBuilderAssistantSession(): {
  sessionId: string;
  categoryId: string | null;
  reportOnly: boolean;
} | null {
  const raw = sessionStorage.getItem(KEY);
  if (!raw) return null;
  sessionStorage.removeItem(KEY);
  try {
    const parsed = JSON.parse(raw) as { sessionId?: string; categoryId?: string | null; reportOnly?: boolean };
    if (!parsed.sessionId) return null;
    return {
      sessionId: parsed.sessionId,
      categoryId: parsed.categoryId ?? null,
      reportOnly: parsed.reportOnly === true,
    };
  } catch {
    return null;
  }
}
